import { render, staticRenderFns } from "./ExchangesForm.vue?vue&type=template&id=244de133&"
import script from "./ExchangesForm.vue?vue&type=script&lang=js&"
export * from "./ExchangesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports